import router from './index'
import store from '@/store'
import { ElMessage } from 'element-plus'
import { i18n } from '@/i18n'

// 白名单路由
const whiteList = ['/login']

// 模拟获取菜单数据的API
const getMenuData = () => {
  return new Promise((resolve) => {
    // 模拟API调用
    setTimeout(() => {
      const menuData = {
        "code": 0,
        "count": 0,
        "data": {
          "responseMenus": [
            {
              "children": [],
              "isSelect": 1,
              "menuCode": "INDEX",
              "menuName": "首页",
              "menuPage": "dashboard",
              "menuType": 1,
              "target": "FrmContent"
            },
            {
              "children": [
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "EQUM_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "EQUM_add",
                      "menuName": "添加设备编号",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "EQUM_clear",
                      "menuName": "一键清理测试数据",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "EQUM_inputCard",
                      "menuName": "写入CardID",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "EQUM_upStatus",
                      "menuName": "修改状态",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "EQUM_export",
                      "menuName": "导出设备",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "EQUM_chongzhi",
                      "menuName": "充值水量",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "EQUM_volRecord",
                      "menuName": "充值记录",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "EQUM_upType",
                      "menuName": "修改类型",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "EQUM_upOrg",
                      "menuName": "移交机构",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "EQUM",
                  "menuName": "设备&滤芯库",
                  "menuPage": "equAdmin",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "LVXM_search",
                      "menuName": "查询",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "LVXM",
                  "menuName": "换芯记录",
                  "menuPage": "equLvRecord",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "UIVERSION_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "UIVERSION_add",
                      "menuName": "发布新版本",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "UIVERSION_edit",
                      "menuName": "修改",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "UIVERSION_download",
                      "menuName": "下载",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "UIVERSION_del",
                      "menuName": "删除",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "UIVERSION",
                  "menuName": "家用版本库",
                  "menuPage": "equFileVersionAdmin",
                  "menuType": 2,
                  "target": "FrmContent"
                }
              ],
              "isSelect": 1,
              "menuCode": "DATAM",
              "menuName": "设备管理",
              "menuPage": "",
              "menuType": 1,
              "target": "FrmContent"
            },
            {
              "children": [
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "HEART_search",
                      "menuName": "查询",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "HEART",
                  "menuName": "心跳上报数据",
                  "menuPage": "equHeartBeat",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "CUSTOM_search",
                      "menuName": "查询",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "CUSTOM",
                  "menuName": "单次使用数据",
                  "menuPage": "equCustomerRecord",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "EQUACT_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "EQUACT_export",
                      "menuName": "导出数据",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "EQUACT_upWater",
                      "menuName": "修改数据",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "EQUACT",
                  "menuName": "绑定信息统计",
                  "menuPage": "equActive",
                  "menuType": 2,
                  "target": "FrmContent"
                }
              ],
              "isSelect": 1,
              "menuCode": "DATAQ",
              "menuName": "TCP数据查询",
              "menuPage": "",
              "menuType": 1,
              "target": "FrmContent"
            },
            {
              "children": [
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "ORG_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "ORG_edit",
                      "menuName": "编辑",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "ORG_del",
                      "menuName": "删除",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "ORG_secret",
                      "menuName": "查看密钥",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "ORG_add",
                      "menuName": "添加",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "ORG_detail",
                      "menuName": "详情",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "ORGM",
                  "menuName": "客户管理",
                  "menuPage": "orgAdmin",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "AGENTCHECK_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "AGENTCHECKL_check",
                      "menuName": "审核",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "AGENTCHECK",
                  "menuName": "代理商审核",
                  "menuPage": "equAgent",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "AGENTCPS_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "AGENTCPS_add",
                      "menuName": "添加",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "AGENTCPS_edit",
                      "menuName": "编辑",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "AGENTCPS_del",
                      "menuName": "删除",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "AGENTCPS",
                  "menuName": "代理商分润管理",
                  "menuPage": "equAgentCps",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "AGENTROUTE_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "AGENTROUTE_add",
                      "menuName": "添加",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "AGENTROUTE_edit",
                      "menuName": "编辑",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "AGENTROUTE_del",
                      "menuName": "删除",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "AGENTROUTE_config",
                      "menuName": "配置",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "AGENTROUTE_status",
                      "menuName": "状态",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "AGENTROUTE",
                  "menuName": "推广路线配置",
                  "menuPage": "equRouteConfig",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "PARTY_A_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "PARTY_A_add",
                      "menuName": "添加",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "PARTY_A_edit",
                      "menuName": "编辑",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "PARTY_A_del",
                      "menuName": "删除",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "PARTY_A",
                  "menuName": "甲方类型管理",
                  "menuPage": "orgLibConfig",
                  "menuType": 2,
                  "target": "FrmContent"
                }
              ],
              "isSelect": 1,
              "menuCode": "CRMM",
              "menuName": "甲方库",
              "menuPage": "",
              "menuType": 1,
              "target": ""
            },
            {
              "children": [
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "STATUSM_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "STATUSM_detail",
                      "menuName": "历史记录",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "STATUSM",
                  "menuName": "状态查询",
                  "menuPage": "statusAdmin",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "OUTORDERM_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "OUTORDERM_view",
                      "menuName": "出水明细",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "OUTORDERM",
                  "menuName": "出水记录查询",
                  "menuPage": "statusDetail",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "DEBUGER_search",
                      "menuName": "查询",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "DEBUGER",
                  "menuName": "设备调试页面",
                  "menuPage": "equStatus",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "WATERTTL_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "WATERTTL_export",
                      "menuName": "导出",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "WATERTTL",
                  "menuName": "出水总量查询",
                  "menuPage": "equWaterTTL",
                  "menuType": 2,
                  "target": "FrmContent"
                }
              ],
              "isSelect": 1,
              "menuCode": "MQTTM",
              "menuName": "MQTT数据查询",
              "menuPage": "",
              "menuType": 1
            },
            {
              "children": [
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "ACCTMA_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "ACCTMA_add",
                      "menuName": "添加账号",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "ACCTMA_edit",
                      "menuName": "编辑",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "ACCTMA_reset",
                      "menuName": "密码重置",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "ACCTMA_remenu",
                      "menuName": "权限控制",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "ACCTMA",
                  "menuName": "管理员帐号",
                  "menuPage": "equUser",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "TYPEM_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "TYPEM_edit",
                      "menuName": "修改",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "TYPEM_del",
                      "menuName": "删除",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "TYPEM_add",
                      "menuName": "添加",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "TYPEM",
                  "menuName": "设备类型管理",
                  "menuPage": "equTypeMain",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "SETM_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "SETM_edit",
                      "menuName": "修改",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "SETM_del",
                      "menuName": "删除",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "SETM_add",
                      "menuName": "添加",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "SETM",
                  "menuName": "系统默认设置",
                  "menuPage": "equSettingMain",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "SETM_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "SETM_edit",
                      "menuName": "修改",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "SETM_del",
                      "menuName": "删除",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "SETM_add",
                      "menuName": "添加",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "SETM_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "SETM_edit",
                      "menuName": "修改",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "SETM_del",
                      "menuName": "删除",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "SETM_add",
                      "menuName": "添加",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "VOLMAP",
                  "menuName": "出水流量个性化配置",
                  "menuPage": "equOutVolMapMain",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "WATER_CONFIG_search",
                      "menuName": "查询",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "WATER_CONFIG_add",
                      "menuName": "添加",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "WATER_CONFIG_edit",
                      "menuName": "编辑",
                      "menuType": 3
                    },
                    {
                      "isSelect": 1,
                      "menuCode": "WATER_CONFIG_del",
                      "menuName": "删除",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "WATER_CONFIG",
                  "menuName": "温度水量配置",
                  "menuPage": "equWaterConfig",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [
                    {
                      "isSelect": 1,
                      "menuCode": "BUSSLOG_search",
                      "menuName": "查询",
                      "menuType": 3
                    }
                  ],
                  "isSelect": 1,
                  "menuCode": "BUSSLOG",
                  "menuName": "业务日志",
                  "menuPage": "equlog",
                  "menuType": 2,
                  "target": "FrmContent"
                }
              ],
              "isSelect": 1,
              "menuCode": "ACCTM",
              "menuName": "系统管理",
              "menuPage": "",
              "menuType": 1,
              "target": "FrmContent"
            },
            {
              "children": [
                {
                  "actions": [],
                  "isSelect": 1,
                  "menuCode": "WX_PAY_ORDER",
                  "menuName": "订单管理",
                  "menuPage": "wxPayOrder",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [],
                  "isSelect": 1,
                  "menuCode": "WX_PAY_ORDER",
                  "menuName": "日志管理",
                  "menuPage": "wxPayLog",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [],
                  "isSelect": 1,
                  "menuCode": "WX_PAY_STAT",
                  "menuName": "数据统计",
                  "menuPage": "wxPayStatistics",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [],
                  "isSelect": 1,
                  "menuCode": "WX_PAY_WATER_CONFIG",
                  "menuName": "水量价格配置",
                  "menuPage": "waterPriceConfig",
                  "menuType": 2,
                  "target": "FrmContent"
                },
                {
                  "actions": [],
                  "isSelect": 1,
                  "menuCode": "WX_PAY_WATER_RECHARGE",
                  "menuName": "充值",
                  "menuPage": "waterRecharge",
                  "menuType": 2,
                  "target": "FrmContent"
                }
              ],
              "isSelect": 1,
              "menuCode": "WX_PAY",
              "menuName": "支付管理",
              "menuPage": "",
              "menuType": 1,
              "target": "FrmContent"
            }
          ],
          "userName": "admin"
        },
        "msg": "success"
      }
      resolve(menuData.data)
    }, 1000)
  })
}

router.beforeEach(async (to, from, next) => {
  // 获取token
  const token = store.state.user.token
  
  if (token) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      // 检查是否已经生成过路由
      const hasRoutes = store.state.menu.routes.length > 0
      if (hasRoutes) {
        next()
      } else {
        try {
          // 获取用户信息
          const userInfo = await store.dispatch('user/getInfo')
          
          // 获取菜单数据
          const menuData = await getMenuData()
          
          // 生成动态路由
          const accessRoutes = await store.dispatch('menu/generateRoutes', menuData)
          
          // 根据用户权限过滤菜单
          await store.dispatch('menu/filterMenusByUserPermissions', userInfo)
          
          // 动态添加路由
          accessRoutes.forEach(route => {
            router.addRoute(route)
          })
          
          // 添加404页面
          router.addRoute({
            path: '/:pathMatch(.*)*',
            name: 'NotFound',
            component: () => import('@/views/error/404.vue')
          })
          
          // 确保菜单数据已加载完成
          await new Promise(resolve => setTimeout(resolve, 100))
          
          // 重新导航到目标路由
          next({ ...to, replace: true })
        } catch (error) {
          console.error('路由生成失败:', error)
          ElMessage.error(i18n.global.t('common.routeLoadFailed'))
          next('/login')
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
    }
  }
})
